// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__saEiP","showModal":"Modal_showModal__8mfZT","outer":"Modal_outer__ssm4J","close":"Modal_close__Xzd62"};